<template>
  <Teleport to="body">
    <dialog
      ref="dialog"
      class="modal"
      :class="{ 'is-active': modelValue, widen: isLarge }"
      closedby="any"
      v-on:close="close"
    >
      <div
        class="modal-card"
        :class="{ 'show-overflow': allowOverflow }"
      >
        <header class="modal-card-head">
          <slot name="header">
            <p
              v-if="title"
              class="modal-card-title"
            >
              {{ title }}
            </p>
          </slot>
          <button
            class="delete ml-3"
            type="button"
            v-on:click="close"
          ></button>
        </header>
        <section
          class="modal-card-body"
          :class="{ 'show-overflow': allowOverflow }"
        >
          <slot :close="close"></slot>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-flex-end">
          <slot
            name="footer"
            :close="close"
          >
            <button
              v-if="showButton"
              autofocus
              class="button"
              type="button"
              v-on:click="close"
            >
              OK
            </button>
          </slot>
        </footer>
      </div>
    </dialog>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: {
    'update:modelValue': (value: boolean) => typeof value === 'boolean',
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    // Fixes the modal to 90%
    isLarge: {
      type: Boolean,
      default: false,
    },
    allowOverflow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false)
    },
    onOpen() {
      // This method may get called before the `<dialog>` element is properly available as `$refs.dialog`, so we delay the opening
      this.$nextTick(() => (this.$refs.dialog as HTMLDialogElement).showModal())
    },
    onClose() {
      if (!this.$refs.dialog) return
      const dialog = this.$refs.dialog as HTMLDialogElement
      if (dialog.open) dialog.close()
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) this.onOpen()
        else if (oldValue !== undefined) this.onClose()
      },
    },
  },
  unmounted() {
    // Ensure we activate scrolling again if the modal was opened but suddenly gets destroyed
    this.onClose()
  },
})
</script>

<style lang="scss" scoped>
dialog.modal {
  padding: 0;
  border: none;
  background: none;
  z-index: initial;

  &.widen {
    min-width: 90%;
    & .modal-card {
      width: 100%;
    }
  }
}

dialog.modal::backdrop {
  background-color: var(--bulma-modal-background-background-color);
}

.modal-card {
  /* Make modal dialogs resizable */
  width: initial;
  max-width: 100%;
  /* Reset styles set by parent elements */
  color: black;
}
footer > button {
  // eventually override the default css for .field.has-addons .control:first-child:last-child .button which removes the rounded edges
  border-radius: 4px !important;
}
/*
 * Allow overflowing, in order to correctly display dropdown selects
 */
.show-overflow {
  overflow: visible;
}
</style>
